.toolbar {
  display: flex;
  padding: 0.5rem 0;
  margin: 0.5rem 0;
}
@media all and (orientation: portrait) {
  .toolbar {
    width: 100%;
  }
}

.datatable {
  margin: 1rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL1dvcmtlclN0YXR1c1JlcG9ydCIsInNvdXJjZXMiOlsiY2xhc3Nlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUxGO0lBTUk7Ozs7QUFJSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiXG4udG9vbGJhciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBhZGRpbmc6IDAuNXJlbSAwO1xuICBtYXJnaW46IDAuNXJlbSAwO1xuXG4gIEBtZWRpYSBhbGwgYW5kIChvcmllbnRhdGlvbjogcG9ydHJhaXQpIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxufVxuXG4uZGF0YXRhYmxlIHtcbiAgbWFyZ2luOiAxcmVtO1xufSJdfQ== */